import React from 'react';

const SvgFilter = props => (
  <svg width={9} height={9} {...props}>
    <path
      d="M8.941.276a.507.507 0 0 1-.04.537L5.986 4.82l-.004.007a.657.657 0 0 0-.136.396v2.653a.489.489 0 0 1-.339.478l-1.634.608a.522.522 0 0 1-.567-.11.503.503 0 0 1-.152-.362V5.222a.66.66 0 0 0-.137-.399l.001.003c0-.002 0-.002-.003-.005L.1.814A.507.507 0 0 1 .059.276.52.52 0 0 1 .52 0h7.96a.52.52 0 0 1 .461.276zm-.896.456H.955L3.616 4.39c.182.241.28.532.281.832v2.947l1.206-.449V5.222c0-.3.098-.59.28-.83L8.045.731z"
      fill="#9A9EB0"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgFilter;
